// 商品数据弹窗
import goodsSourceManager from '@/pages/design/more/goods-source-manager/index';

// Main code
export default {
  i18n: require('../../design_i18n'),
  props: {
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    // subject： 专题； default： 商品列表，
    type: String
  },
  components: {
    goodsSourceManager: goodsSourceManager
  },
  data: function data() {
    return {
      current_value: {},
      dataid: {},
      goodsData: [],
      dialogShow: false
    };
  },
  created: function created() {},
  watch: {
    data: function data(val) {
      this.goodsData = val;
    }
  },
  computed: {
    curValue: function curValue() {
      return this.value;
    },
    products: {
      get: function get() {
        return this.curValue;
      },
      set: function set(val) {
        this.$emit('input', val);
      }
    },
    // 当前组件ID
    component_id: function component_id() {
      return this.$store.state.design.selected_id;
    },
    // 是否已经设置数据
    is_data_set: function is_data_set() {
      return this.products.length > 0;
    },
    // 提示文案
    tips: function tips() {
      return this.$t('com.alreadySelected', {
        num: this.products.length
      });
    }
  },
  methods: {
    handleGoodsAdd: function handleGoodsAdd(item) {
      this.$emit('goodsadd', item);
    },
    /**
     * 打开商品数据配置的弹窗
     */
    handle_open_dialog: function handle_open_dialog() {
      this.$refs.goodsSourceManager.show(this.products);
    },
    /**
     * 商品数据配置弹窗 - 确认回调
     * @param {Array} list 商品数据列表
     */
    handle_dialog_confirm: function handle_dialog_confirm(list) {
      this.products = list;
      // this.$emit('confirm', this.goodsData)
    }
  }
};